export type ClauseGuidanceSaveDecision =
    | { kind: "none" }
    | { kind: "create" | "update"; guidance: string }
    | { kind: "delete" };

export type ClauseGuidanceWriteDecision = Exclude<
    ClauseGuidanceSaveDecision,
    { kind: "none" }
>;

const VISIBLE_GUIDANCE_CHARACTER = /[^\p{Zs}\p{Zl}\p{Zp}\p{Cc}\p{Cf}]/u;

export const decideClauseGuidanceSave = (input: {
    own: { guidance: string } | null;
    initialValue: string;
    value: string;
}): ClauseGuidanceSaveDecision => {
    const value = input.value.trim();
    if (value === input.initialValue.trim()) return { kind: "none" };
    if (!VISIBLE_GUIDANCE_CHARACTER.test(input.value))
        return input.own ? { kind: "delete" } : { kind: "none" };
    return {
        kind: input.own ? "update" : "create",
        guidance: input.value,
    };
};
